import { ToolEditorProvider } from "components/ToolEditor/Provider/ToolEditorProvider";
import { ToolEditorForm } from "./Form/ToolEditorForm";

export interface ToolEditorProps {
  toolVersionId: number;
}
export const ToolEditor = ({ toolVersionId }: ToolEditorProps) => {
  return (
    <ToolEditorProvider toolVersionId={toolVersionId}>
      <ToolEditorForm />
    </ToolEditorProvider>
  );
};
